<template>
	<div>
		<headdv  ></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<div style="height:10px;"></div>
				<el-tabs type="border-card">
					<el-tab-pane :label="item.ph_name" v-for="(item,index) in navList" :key="index">
						<el-form ref="form" :model="item" label-width="100px">
							<el-form-item label="Title:">
								<el-input v-model="item.ph_title" placeholder="例：{strNovelTitle}最新章节列表_{strNovelTitle}最新章节目录_{strWebName}"></el-input>
							</el-form-item>
							<el-form-item label="Keywords:">
								<el-input type="textarea" v-model="item.ph_keywords" placeholder="例：{strNovelTitle},最新章节,章节列表,{strNovelTitle},最新章节,目录,{strWebName}"></el-input> 
							</el-form-item>
							<el-form-item label="Description:">
								<el-input type="textarea" v-model="item.ph_description" placeholder="例：{strNovelTitle}************;*************{strNovelTitle};*************{strWebName}"></el-input>
							</el-form-item>
							<el-form-item label="统计代码:" v-if="item.ph_code == 'index'">
								<el-input type="textarea" v-model="item.ph_statistics" placeholder="例： <script> console.log('这些是统计代码')</script>"></el-input>
							</el-form-item>
							<el-form-item label="其它配置:">
								<el-input type="textarea" v-model="item.ph_other_conf" placeholder="注意：所填内容均为head里的内容"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="save(item)">立即保存 </el-button>
								<el-button>取消</el-button>
								<!-- <el-button type="danger" @click="tapClearFun(item)">清除缓存 </el-button> -->
								<!-- <el-button type="warning" @click="onSubmit" v-if="item.id == 6">生成缓存 </el-button> -->
							</el-form-item>
						</el-form>
						<div class="changshu_dv">
							<div class="changshu_dv_title">参数说明：</div>
							<div class="changshu_dv_info">
								<ul class="flex-more">
									<li>
										<span>网站标题:</span><span>{strWebName}</span>
									</li>
									<li>
										<span>小说标题:</span><span>{strNovelTitle}</span>
									</li>
									<li>
										<span>小说作者:</span><span>{strNovelAuthor}</span>
									</li>
									<li>
										<span>小说分类名:</span><span>{strNovelClass}</span>
									</li>
									
									<li>
										<span>章节标题:</span><span>{strChapterTitle}</span>
									</li>
									<li>
										<span>排行榜标题:</span><span>{strLeaderboard}</span>
									</li>
									<li>
										<span>小说主角(没有数据):</span><span>{strNovelLead}</span>
									</li>
									<li>
										
									</li>
								</ul>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
				
			</div>
		</div>

		<!-- 底部 -->
		<footerdv></footerdv>

		<!-- 保存 -->
		<el-dialog :visible.sync="setHeaderStatus" width="400px" class="dialog">
			<div class="dialog-title" slot="title">保存</div>
			<span>确定保存?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="setHeaderStatus=false">取 消</el-button>
				<el-button type="primary" @click="setHeaderFun">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 删除 -->
		<el-dialog :visible.sync="delCacheStatus" width="400px" class="dialog">
			<div class="dialog-title" slot="title">清除缓存</div>
			<span>确定清除缓存?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="delCacheStatus=false">取 消</el-button>
				<el-button type="primary" @click="clear">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			headData:{
				title:'后台账号列表',
				add:false,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			searchVal:'',
			//分组id
			accountList: [], //列表数据

			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
		  },
		  activeName: 'first',
		  navList:[
				  {id:1,name:'首页',data:{}},
				  {id:2,name:'分类页',data:{}},
				  {id:3,name:'排行榜',data:{}},
				  {id:4,name:'详情页',data:{}},
				  {id:5,name:'目录页',data:{}},
				  {id:6,name:'章节页',data:{}},
				  {id:7,name:'搜索页',data:{}},
		  ],
		  delCacheStatus:false, 
		  setHeaderStatus:false
		};
	},
	created() {
		this.getclasslist();
	},
	methods: {
		//展示删除弹窗
		tapClearFun(data){
			this.delCacheStatus = true, 
			this.form = data
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
	  	//点击保存
		save(data) {
			//如果是首页保存 所有 都要保存一次
			if(data.ph_code == 'index'){
				this.navList.forEach((item,index) => {
					this.form = data
					this.setHeaderFun()
				});
			}else{
				this.form = data
				this.setHeaderStatus = true
				console.log('submit!',data);
			}	
	  	},
	  	//确定保存
		setHeaderFun(){
			this.https(this.apiList.setPageHeader, this.form).then(
					(response) => {
					if (response.data.code == this.common.code) {
						this.getclasslist();
						//弹窗提示
						this.tc_element(response.data.msg, response.data.code, 2, "设置系统header");
					}
					this.setHeaderStatus = false; //隐藏提示框
					}
				);
		},
		//确定清除缓存
		clear(data) {
			console.log('submit!',data);
			this.https(this.apiList.clearCache+`?type=${data.ph_id}` ).then(response => {
				if (response.data.code == this.common.code) {
					this.delCacheStatus =  false
					this.tc_element(response.data.msg,response.data.code,2,"清除缓存")
				}
			})
		},
		//获取列表数据--用户列表
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = ``;
			this.https(this.apiList.getPageHeader + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
				this.navList = response.data.data;              //列表数据
				this.navList.forEach((item,index) => {
					if(index != 0){
						item.ph_statistics = this.navList[0].ph_statistics
					}
				});
				}
			});
		},
		
		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
				this.searchVal = data
				this.getclasslist();
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1
        condition1(){
			  this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选3
        condition3(){
            console.log('condition3')
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
        },
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
		  //格式化内容--时间
			formatter_time(row, column, cellValue, index) {
				let time = this.gettime.format(cellValue*1000,3) 
				return time;
			},
	},
};
</script>
<style lang="scss" scoped>
.changshu_dv{
	margin-top:20px;
	.changshu_dv_title{
		color:red;
		margin-bottom:10px;
	}
	.changshu_dv_info{
		margin-left:40px;
		ul{
			li{
				margin:10px 40px 0 0;
				min-width: 220px;
				//margin-right:40px;
				span{
					margin-right:10px;
				}
			}
		}
	}
}
::v-deep .el-tabs{
	padding-bottom:20px;
	box-sizing: border-box;
}
::v-deep .el-textarea .el-textarea__inner {
	min-height: 100px!important;
}
::v-deep .el-input , .el-textarea{
	width:800px;
}
// 表格样式
::v-deep .el-table  {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>